export interface SeoMeta {
  title: string | null;
  description: string | null;
  keywords: string | null;
  indexable: boolean;
}

const upsertMeta = (name: string, content: string | null): void => {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!content) {
    if (tag && tag.dataset.dynamic === 'true') {
      tag.remove();
    }
    return;
  }
  if (!tag) {
    tag = document.createElement('meta');
    tag.name = name;
    tag.dataset.dynamic = 'true';
    document.head.appendChild(tag);
  }
  tag.content = content;
};

/**
 * Applica i meta SEO dell'evento corrente (titolo, description, keywords, robots).
 * Nota: SPA client-side — efficace per Google, non per i crawler social.
 */
export const applyEventMeta = (meta: SeoMeta | null | undefined): void => {
  if (!meta) {
    return;
  }
  if (meta.title) {
    document.title = meta.title;
  }
  upsertMeta('description', meta.description);
  upsertMeta('keywords', meta.keywords);
  upsertMeta('robots', meta.indexable ? null : 'noindex, nofollow');
};
